import { render, staticRenderFns } from "./CreateProjectModal.vue?vue&type=template&id=223c54b4&"
import script from "./CreateProjectModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports